import React, { useMemo, useState } from 'react';
import useOperationalStore, {
  PIPELINE,
  fmtAge,
  getStageForStatus,
  getStageAge,
} from '../../platform/store/useOperationalStore';
import './MobileJobsList.css';

// Phone-native Jobs list: stage filter chips + tappable RO cards.
// Tap opens the RO detail panel (bottom sheet on mobile).

const STAGE_COLORS = {
  'ro-creation': '#6366f1',
  diag:          '#0ea5e9',
  approval:      '#f59e0b',
  parts:         '#8b5cf6',
  repair:        '#22c55e',
  verify:        '#06b6d4',
  pmt:           '#3b82f6',
};

export default function MobileJobsList() {
  const trucks = useOperationalStore(s => s.trucks);
  const setSelected = useOperationalStore(s => s.setSelectedTruckId);
  const [stageFilter, setStageFilter] = useState('all');

  const active = useMemo(
    () => trucks
      .filter(t => !['completed', 'voided'].includes(t.status))
      .sort((a, b) => (b.lastStatusChange || 0) - (a.lastStatusChange || 0)),
    [trucks]
  );

  const visible = stageFilter === 'all'
    ? active
    : active.filter(t => getStageForStatus(t.status)?.id === stageFilter);

  return (
    <div className="mjl-root">
      <div className="mjl-chips">
        <button
          className={`mjl-chip${stageFilter === 'all' ? ' mjl-chip--active' : ''}`}
          onClick={() => setStageFilter('all')}
        >
          All <em>{active.length}</em>
        </button>
        {PIPELINE.map(stage => {
          const count = active.filter(t => stage.statuses.includes(t.status)).length;
          if (!count) return null;
          return (
            <button
              key={stage.id}
              className={`mjl-chip${stageFilter === stage.id ? ' mjl-chip--active' : ''}`}
              onClick={() => setStageFilter(prev => prev === stage.id ? 'all' : stage.id)}
            >
              {stage.label} <em>{count}</em>
            </button>
          );
        })}
      </div>

      <div className="mjl-list">
        {visible.length === 0 && (
          <div className="mjl-empty">No repair orders in this view.</div>
        )}
        {visible.map(truck => {
          const stage = getStageForStatus(truck.status);
          const accent = STAGE_COLORS[stage?.id] || '#94a3b8';
          const age = getStageAge(truck);
          const techs = (truck.techNumbers || []).filter(Boolean);
          return (
            <button
              key={truck.id}
              className="mjl-card"
              style={{ borderLeftColor: truck.isHardDown ? '#dc2626' : accent }}
              onClick={() => setSelected(truck.id)}
            >
              <div className="mjl-card-top">
                <span className="mjl-ro">{truck.repairOrder}</span>
                <span className="mjl-stage" style={{ color: accent }}>{stage?.label || truck.status}</span>
              </div>
              <div className="mjl-company">{truck.companyName || '—'}</div>
              <div className="mjl-sub">
                {truck.truckNumber && <span>#{truck.truckNumber}</span>}
                {[truck.year, truck.make, truck.model].filter(Boolean).length > 0 && (
                  <span>{[truck.year, truck.make, truck.model].filter(Boolean).join(' ')}</span>
                )}
              </div>
              <div className="mjl-meta">
                {truck.isHardDown && <span className="mjl-fd">HARD DOWN</span>}
                <span className={`mjl-age mjl-age--${age.level || 'fresh'}`}>
                  {fmtAge(truck.lastStatusChange)} in stage
                </span>
                {techs.length > 0 && <span className="mjl-techs">Tech {techs.join(', ')}</span>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
